import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ProductReviewPagination } from '@spa/generated/graphql/graphql';
import styles from './bazaarvoice-review-pagination.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly pagination: ProductReviewPagination;
  readonly onPageChange: (pageIdx: number) => void;
  readonly disabled?: boolean;
}
function BazaarvoiceReviewPaginationComponent(t0) {
  const $ = _c(33);
  const {
    pagination,
    onPageChange,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  const {
    pageIdx,
    pageSize,
    totalResults,
    hasNextPage
  } = pagination;
  const rangeFrom = totalResults === 0 ? 0 : pageIdx * pageSize + 1;
  const rangeTo = Math.min((pageIdx + 1) * pageSize, totalResults);
  const hasPreviousPage = pageIdx > 0;
  let t2;
  if ($[0] !== formatMessage || $[1] !== rangeFrom || $[2] !== rangeTo || $[3] !== totalResults) {
    t2 = formatMessage("paginationRange", {
      rangeFrom,
      rangeTo,
      totalResults
    });
    $[0] = formatMessage;
    $[1] = rangeFrom;
    $[2] = rangeTo;
    $[3] = totalResults;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span className={styles["bazaarvoice-review-pagination__range"]}>{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = !hasPreviousPage || disabled;
  let t5;
  if ($[7] !== formatMessage) {
    t5 = formatMessage("previousPageAriaLabel");
    $[7] = formatMessage;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onPageChange || $[10] !== pageIdx) {
    t6 = () => onPageChange(pageIdx - 1);
    $[9] = onPageChange;
    $[10] = pageIdx;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ImageComponent src="/assets/icons/arrow_back.svg" alt="" width={20} height={20} />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t8 = <button type="button" className={styles["bazaarvoice-review-pagination__button"]} disabled={t4} aria-label={t5} onClick={t6}>{t7}</button>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = !hasNextPage || disabled;
  let t10;
  if ($[17] !== formatMessage) {
    t10 = formatMessage("nextPageAriaLabel");
    $[17] = formatMessage;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onPageChange || $[20] !== pageIdx) {
    t11 = () => onPageChange(pageIdx + 1);
    $[19] = onPageChange;
    $[20] = pageIdx;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ImageComponent src="/assets/icons/arrow_forward.svg" alt="" width={20} height={20} />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t9) {
    t13 = <button type="button" className={styles["bazaarvoice-review-pagination__button"]} disabled={t9} aria-label={t10} onClick={t11}>{t12}</button>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t8) {
    t14 = <div className={styles["bazaarvoice-review-pagination__controls"]}>{t8}{t13}</div>;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14 || $[31] !== t3) {
    t15 = <div className={styles["bazaarvoice-review-pagination"]}>{t3}{t14}</div>;
    $[30] = t14;
    $[31] = t3;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}
export default memo(BazaarvoiceReviewPaginationComponent);